module.exports = __webpack_public_path__ + "img/icon_warn@3x.fa8b8b84.png";